export const validDaysList = [
  { value: 1, label: '1' },
  { value: 3, label: '3' },
  { value: 5, label: '5' },
  { value: 7, label: '7' },
  { value: 15, label: '15' },
  { value: 30, label: '30' },
  { value: 0, label: '永久' }
]

export const assignWorkList = [
  { id: 0, name: '全部' },
  { id: 1, name: '个人' },
  { id: 2, name: '劳务班组' },
  { id: 3, name: '企业' }
]

export const publicityBetweenList = [
  { id: 1, name: '1' },
  { id: 2, name: '2' },
  { id: 3, name: '3' },
  { id: 4, name: '4' },
  { id: 5, name: '5' },
  { id: 6, name: '6' },
  { id: 7, name: '7' },
  { id: 8, name: '8' },
  { id: 9, name: '9' },
  { id: 10, name: '10' }
]
